import { render, staticRenderFns } from "./TableWrap.vue?vue&type=template&id=3fa8ec38&"
import script from "./TableWrap.vue?vue&type=script&lang=js&"
export * from "./TableWrap.vue?vue&type=script&lang=js&"
import style0 from "./TableWrap.vue?vue&type=style&index=0&id=3fa8ec38&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports